<template>
  <v-card
    :class="isMobile == true ? 'my-2' : 'my-3'"
    :elevation="isMobile == true ? 0 : 3"
  >
    <v-toolbar color="grey lighten-2">
      <v-icon class="mr-3">mdi-filter</v-icon>
      <v-toolbar-title class="subtitle-1">
        Filtrar resultados
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn> -->
    </v-toolbar>
    <v-card
      class="mx-auto overflow-y-auto"
      :height="
        isMobile ? innerHeight / 2 + 'px' : (innerHeight - 350) / 2 + 'px'
      "
      flat
    >
      <!-- COMPONENTE DE FILTROS POR ANO -->
      <filtros-ano
        :anos="filtrosBusca"
        @filtrarAggregations="filtrarAggregations"
      />
      <!-- COMPONENTE DE FILTROS POR RELATOR -->
      <relator
        :relatores="filtrosBusca"
        @filtrarAggregations="filtrarAggregations"
      />
      <!-- COMPONENTE DE FILTROS TIPO DE DECISÃO -->
      <tipo-decisao
        :tiposDecisao="filtrosBusca"
        @filtrarAggregations="filtrarAggregations"
      />
      <!-- COMPONENTE DE FILTROS POR CLASSIFICAÇÃO TEMÁTICA -->
      <!-- <classificacao-tematica
        :classificacoesTematicas="filtrosBusca"
        @filtrarAggregations="filtrarAggregations"
      /> -->
      <!-- COMPONENTE DE FILTROS POR PARADIGMATICA -->
      <!-- <paradigmatica
        :paradigmaticas="filtrosBusca"
        @filtrarAggregations="filtrarAggregations"
      /> -->
      <!-- COMPONENTE DE FILTROS POR PARADIGMATICA -->
      <!-- <assunto-descritor
        :assuntos="filtrosBusca"
        @filtrarAggregations="filtrarAggregations"
      /> -->
      <!-- COMPONENTE DE FILTROS POR PARADIGMATICA -->
      <!-- <emissor
        :emissores="filtrosBusca"
        @filtrarAggregations="filtrarAggregations"
      /> -->
      <!-- COMPONENTE DE FILTROS POR PARADIGMATICA -->
      <!-- <normativo
        :normativos="filtrosBusca"
        @filtrarAggregations="filtrarAggregations"
      /> -->
    </v-card>
  </v-card>
</template>
<script>
// import FiltrosRelevancia from "@/shared/FiltrosRelevancia";
import FiltrosAno from "@/shared/FiltrosAnoJurisprudencia";
import TipoDecisao from "@/shared/jurisprudencia/selecionada/aggregations/TipoDecisao";
import Relator from "@/shared/jurisprudencia/selecionada/aggregations/Relator";
// import ClassificacaoTematica from "@/shared/jurisprudencia/selecionada/aggregations/ClassificacaoTematica";
// import Paradigmatica from "@/shared/jurisprudencia/selecionada/aggregations/Paradigmatica";
// import AssuntoDescritor from "@/shared/jurisprudencia/selecionada/aggregations/AssuntoDescritor";
// import Emissor from "@/shared/jurisprudencia/selecionada/aggregations/Emissor";
// import Normativo from "@/shared/jurisprudencia/selecionada/aggregations/Normativo";
export default {
  props: {
    filtrosBusca: { type: Object },
    resultsMobile: { type: Boolean, default: false },
    isMobile: { type: Boolean, default: false }
  },
  components: {
    FiltrosAno,
    TipoDecisao,
    // ClassificacaoTematica,
    // Paradigmatica,
    // AssuntoDescritor,
    // Emissor,
    // Normativo,
    Relator
  },
  data() {
    return {
      innerHeight: window.innerHeight,
      height: window.innerHeight - 50 + "px"
    };
  },
  methods: {
    filtrarAggregations(item) {
      item.historico = false;
      // item.termo = this.filtrosFormulario.termo;
      this.$emit("filtrarAggregations", item);
    }
  }
};
</script>
